<p>financial-accounts-core-main works!</p>
<router-outlet></router-outlet>
